export default "__VITE_ASSET__BouUI0c6__"